import script from "./MenuLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLinks.vue?vue&type=script&setup=true&lang=js"

import "./MenuLinks.vue?vue&type=style&index=0&id=461acaad&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461acaad"]])

export default __exports__